import { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Box,
  Tooltip,
  IconButton,
} from "@mui/material";
import { uploadCollateralApi } from "../../app/slices/collateral/uploadCollateralSlice";
import { updateCollateralApi } from "../../app/slices/collateral/updateCollateralSlice";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";

import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { collateralApi } from "../../app/slices/collateral/collateralSlice";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";
import { useFileTypeValidator } from "../../utils/fileTypeValidator";

export default function CollateralUpload() {
  const dispatch = useDispatch();
  const roleResponse = useSelector((state) => state.login.login.role);

  useEffect(() => {
    dispatch(collateralApi());
  }, [dispatch]);

  const sliceResponse = useSelector(
    (state) => state.collateral.collateral.data,
  );
  // console.log("sliceResponse: ", sliceResponse);
  const stateLoading = useSelector((state) => state.collateral.loading);

  const [formData, setFormData] = useState({
    collateral_upload: null,
    collateral_name: "",
    type: "",
  });
  const maxSize = 7 * 1024 * 1024;
  const allowedExtensions = ["pdf", "png", "jpg", "ppt", "mp4"];
  const { validatedFile, error: fileTypeError } = useFileTypeValidator(
    formData.collateral_upload,
    allowedExtensions,
    maxSize,
  );
  // console.log("formData: ", formData);

  const [errors, setErrors] = useState({
    collateral_upload: false,
    collateral_name: false,
    type: false,
  });

  const validateForm = () => {
    const newErrors = {
      collateral_upload: !formData.collateral_upload,
      collateral_name: formData.collateral_name.trim() === "",
      type: formData.type.trim() === "",
    };
    setErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  // const handleFileChange = (event) => {
  //   setFormData((prev) => ({ ...prev, collateral_upload: event.target.files[0] }));
  //   setErrors((prev) => ({ ...prev, collateral_upload: false }));
  // };
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    setFormData((prev) => ({
      ...prev,
      collateral_upload: file,
    }));

    setErrors((prev) => ({
      ...prev,
      collateral_upload: false,
    }));
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validatedFile) {
      toast.error(fileTypeError);
      return;
    }
    if (validateForm()) {
      try {
        const response = await dispatch(uploadCollateralApi(formData));
        if (response.meta.requestStatus === "fulfilled") {
          Swal.fire({
            text: "Upload Successful!",
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
          });
          dispatch(collateralApi());

          // Reset formData after successful submission
          setFormData({
            collateral_upload: null,
            collateral_name: "",
            type: "",
          });

          // Manually reset the file input field to clear the file name
          document.getElementById("file-input").value = ""; // This clears the input field
        }
      } catch (error) {
        console.log("error: ", error);
      }
    }
  };
  //    ***************************************************** Edit ********************************************
  const [editState, seteditState] = useState(false);

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (!validatedFile && formData.collateral_upload) {
      toast.error(fileTypeError);
      return;
    }
    if (validateForm()) {
      try {
        const response = await dispatch(updateCollateralApi(formData));
        if (response.meta.requestStatus === "fulfilled") {
          Swal.fire({
            text: "Updated Successfully!",
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
          });
          dispatch(collateralApi());
          // Reset formData after successful submission
          setFormData({
            collateral_upload: null,
            collateral_name: "",
            type: "  ",
          });
          seteditState(false);
          // Manually reset the file input field to clear the file name
          document.getElementById("file-input").value = ""; // This clears the input field
        }

        // console.log("response:kkkkkkkkkkkkkkkkkkkkkkkkkkk ", response.data);
      } catch (error) {
        console.log("error: ", error);
      }
    }
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("collateral_name", {
      header: "collateral_name",
      size: 30,
    }),
    columnHelper.accessor("pdfUrl", {
      header: "File",
      size: 30,
      Cell: ({ cell }) => {
        const fileUrl = cell.getValue();
        // const fileExtension = fileUrl?.split('.').pop()?.toLowerCase();

        return (
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "blue",
            }}
          >
            open
          </a>
        );
      },
    }),

    columnHelper.accessor("type", {
      header: "Type",
      size: 30,
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => cell.row.original.updatedAt.split("T")[0],
    }),
  ];

  if (roleResponse?.CollateralUpload?.update === 1) {
    columns.push(
      columnHelper.accessor("Actions", {
        header: "Actions",
        size: 30,
        Cell: ({ cell }) => {
          const rowId = cell.row.original._id;
          const rowData = cell.row.original;

          return (
            <Box>
              {roleResponse?.CollateralUpload?.update === 1 && (
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() => {
                      seteditState(true);
                      setFormData({
                        _id: rowId,
                        collateral_upload: null,
                        collateral_name: rowData?.collateral_name || "",
                        type: rowData?.type || "",
                      });
                      document.getElementById("file-input").value = "";

                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                  >
                    <EditIcon color="error" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      }),
    );
  }

  return (
    <>
      {roleResponse?.CollateralUpload?.write === 1 && (
        <Card sx={{ mb: 4 }}>
          <CardContent>
            <Grid container spacing={1} justifyContent="center">
              <Grid
                item
                xs={12}
                md={editState ? 3 : 3.5}
                lg={editState ? 3 : 3.5}
              >
                <TextField
                  label="collateral_name"
                  variant="outlined"
                  fullWidth
                  name="collateral_name"
                  value={formData.collateral_name}
                  onChange={handleChange}
                  error={errors.collateral_name}
                  helperText={
                    errors.collateral_name ? "collateral_name is required" : ""
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                lg={editState ? 3 : 3.5}
                md={editState ? 3 : 3.5}
              >
                {/* <TextField
                  fullWidth
                  type="file"
                  id="file-input" 
                  name="collateral_upload"
                  onChange={handleFileChange}
                  error={errors.collateral_upload}
                  helperText={errors.collateral_upload ? "File is required" : ""}
                /> */}
                <Box>
                  <TextField
                    fullWidth
                    type="file"
                    id="file-input"
                    name="collateral_upload"
                    onChange={handleFileChange}
                    error={errors.collateral_upload || !!fileTypeError}
                    helperText={
                      errors.collateral_upload
                        ? "File is required"
                        : fileTypeError
                          ? fileTypeError
                          : `Allowed file type ${allowedExtensions
                              .map((format) => `.${format}`)
                              .join(
                                ", ",
                              )} with max size ${maxSize / (1024 * 1024)} MB`
                    }
                    inputProps={{
                      accept: ".pdf,.png,.jpg,.jpeg",
                    }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={editState ? 3 : 3.5}
                lg={editState ? 3 : 3.5}
              >
                <TextField
                  label="type"
                  variant="outlined"
                  fullWidth
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  error={errors.type}
                  helperText={errors.type ? "type is required" : ""}
                />
              </Grid>

              {!editState && (
                <Grid item xs={12} sm={12} md={1.5} lg={1.5} textAlign="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    sx={{
                      p: { xs: 1, sm: 1.8, md: 1.8 },
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "100%",
                        lg: "100%",
                        xl: "100%",
                      },
                      transition: "transform 0.5s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.01)",
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Grid>
              )}
              {editState && (
                <>
                  <Grid item xs={6} sm={6} md={1.5} lg={1.5} textAlign="center">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleUpdate}
                      sx={{
                        p: { xs: 1, sm: 1.8, md: 1.8 },
                        width: {
                          xs: "100%",
                          sm: "100%",
                          md: "100%",
                          lg: "100%",
                          xl: "100%",
                        },
                        transition: "transform 0.5s ease-in-out",
                        "&:hover": {
                          transform: "scale(1.05)",
                        },
                      }}
                    >
                      Update
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm={6} md={1.5} lg={1.5} textAlign="center">
                    <Button
                      variant="contained"
                      onClick={() => {
                        seteditState(false);
                        setFormData({
                          collateral_upload: null,
                          collateral_name: "",
                          type: "",
                        });
                        document.getElementById("file-input").value = "";
                      }}
                      sx={{
                        backgroundColor: "#bc2020 !important",
                        p: { xs: 1, sm: 1.8, md: 1.8 },
                        width: {
                          xs: "100%",
                          sm: "100%",
                          md: "100%",
                          lg: "100%",
                          xl: "100%",
                        },
                        transition: "transform 0.5s ease-in-out",
                        "&:hover": {
                          transform: "scale(1.05)",
                          backgroundColor: "#ca2727",
                        },
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </CardContent>
        </Card>
      )}

      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="CollateralUpload"
      />
    </>
  );
}
